import { useUpdateFlow } from '../../api/useUpdateFlow'
import { Button, Text } from '@mantine/core'
import { FaultStatus } from '../../api/fault.types'

export function AcceptedForm({
  id,
  status,
}: {
  id: number
  status?: FaultStatus
}) {
  const { updateFlow } = useUpdateFlow(id)
  return (
    status === FaultStatus['for-approval'] && (
      <>
        <Text size='xs' mt={4}>
          Czy chcesz zaakceptować?
        </Text>
        <Button
          mt='md'
          mr='md'
          variant='filled'
          color='teal'
          onClick={() => updateFlow({ flow: 5, decision: 'accepted' })}
        >
          Zaaakceptuj
        </Button>
        <Button
          mt='md'
          mr='md'
          variant='filled'
          color='red'
          onClick={() => updateFlow({ flow: 5, decision: 'rejected' })}
        >
          Odrzuć
        </Button>
      </>
    )
  )
}
